import React, { Component, useState, useEffect } from "react";
import ResultTable from "./../results/ResultTable";
import { Route, Link ,NavLink} from "react-router-dom";
import Members from "./Members/Members";
import movieTranslations from "../results/Lang/en.json";
import frenchMovieTranslations from "../results/Lang/ar.json";
import { GetCourseData } from "./API";
import { withLocalize } from "react-localize-redux";

function Course(props) {
  const { params } = props.match;
  let langCode = "en";
  if (props.activeLanguage !== undefined) {
    langCode = props.activeLanguage.code;
  }
  const [data, setData] = useState([]);
  useEffect(() => {

    props.addTranslationForLanguage(movieTranslations, "en");
    props.addTranslationForLanguage(frenchMovieTranslations, "ar");

  }, [])

   useEffect(() => {
    GetCourseData(props.match.params.crsnum).then(data => {
      setData(data);
      console.log(data);
    });
  }, [props.match.params.crsnum]);
  return (
    <div>
      <div class="card card-bottom-tabs">
        <div class="card-block">
          <h4 class="card-title m-t-0">
            {langCode === "ar" ? data.crsNameArabic : data.crsNameEnglish}
          </h4>
          <h6 class="card-subtitle m-b-10 text-muted">
            {langCode === "ar" ? data.depNameArabic : data.depNameEnglish}
          </h6>
        </div>
      </div>

      <ul class="nav card-bottom-tabsUL">
        <li class="nav-items">
          <NavLink
            to={`/course/${props.match.params.crsnum}/`}
            exact
            activeClassName='active'
            className="nav-link  show"
          >
            <span class="d-sm-none">
              {" "}
              <i class="fas fa-info fa-fw text-primecolor" /> Overview{" "}
            </span>
            <span class="d-sm-block d-none">
              {" "}
              <i class="fas fa-info fa-fw text-primecolor" /> Overview
            </span>
          </NavLink>
        </li>

        <li class="nav-items">
          <NavLink
            to={`/course/${props.match.params.crsnum}/elearning`}
            activeClassName='active'

            className="nav-link"
          >
            <span class="d-sm-none">
              {" "}
              <i class="fa fa-fw fa-book text-primecolor" /> Course Content{" "}
            </span>
            <span class="d-sm-block d-none">
              {" "}
              <i class="fa fa-fw fa-book text-primecolor" /> Content
            </span>
          </NavLink>
        </li>

        <li class="nav-items">
          <NavLink
            to={`/course/${props.match.params.crsnum}/community`}
            className="nav-link"
            activeClassName='active'

          >
            <span class="d-sm-none">
              {" "}
              <i class="fas fa-fw fa-comments text-primecolor" /> Community{" "}
            </span>
            <span class="d-sm-block d-none">
              {" "}
              <i class="fas fa-fw fa-comments text-primecolor" /> Community
            </span>
          </NavLink>
        </li>
        <li class="nav-items">
          <NavLink
            to={`/course/${props.match.params.crsnum}/members`}
            className="nav-link"
            activeClassName='active'

          >
            <span class="d-sm-none">
              {" "}
              <i class="fa fa-fw fa-user text-primecolor" /> Course Members{" "}
            </span>
            <span class="d-sm-block d-none">
              {" "}
              <i class="fa fa-fw fa-user text-primecolor" /> Members
            </span>
          </NavLink>
        </li>
        <li class="nav-items">
          <NavLink
            to={`/course/${props.match.params.crsnum}/books`}
            className="nav-link"
            activeClassName='active'

          >
            <span class="d-sm-none">
              {" "}
              <i class="fa fa-fw fa-user text-primecolor" /> Course Book{" "}
            </span>
            <span class="d-sm-block d-none">
              {" "}
              <i class="fa fa-fw fa-user text-primecolor" /> Book
            </span>
          </NavLink>
        </li>
      </ul>

     
    </div>
  );
}

export default withLocalize(Course);



// WEBPACK FOOTER //
// ./src/pages/course/Course.js